<template>
  <div>
    <form class="form" @submit.prevent="updateQuery">
      <input v-model="inputQuery" type="text" id="findDocument"
             class="form-control form__input" placeholder="Search for a document's title"/>
      <button class="form__button" type="submit">Search documents</button>
    </form>

    <p>Search results for "{{ inputQueryCopy }}"</p>

    <template v-if="documents.length !== 0">
      <search-document-results :documents="documents" :keywords="keywords"></search-document-results>
    </template>

    <template v-else>
      <h2>Sorry, we couldn't find anything for "{{ inputQueryCopy }}"</h2>
    </template>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import SearchDocumentResults from './SearchDocumentResults';

  export default {
    name: "SearchDocument",
    components: {
      'search-document-results': SearchDocumentResults,
    },
    data() {
      return {
        documents: [],
        inputQuery: '',
        inputQueryCopy: '',
        keywords: [],
      }
    },
    beforeMount() {
      this.inputQuery = this.$route.query.query;
      this.searchDocument(this.$route.query.query);
    },
    computed: {
      ...mapGetters('login/report', {
        reportList: 'getReportList',
      }),
      ...mapGetters('login/pdf', {
        pdfList: 'getPdfList',
      }),
      ...mapGetters('login/cda', {
        cdaList: 'getCdaList',
      }),
    },
    methods: {
      searchDocument() {
        this.documents = {};
        this.inputQueryCopy = this.inputQuery;

        // break down user input to an array of strings, split by white spaces
        this.keywords = stringToArray(this.inputQuery);
        let regexp = new RegExp(this.keywords.join("|"), "i");

        this.documents['reports'] = this.searchReports(regexp);
        // this.documents['pdfs'] = this.searchPdfs(regexp);
        this.documents['cdas'] = this.searchCdas(regexp);
      },

      // TODO put these search methods into a separate file; may be used by the search in the navigation bar
      searchReports(regexp) {
        let reports = [];

        this.reportList.forEach(report => {
          if (regexp.test(report.displayName)) {
            reports.push(report);
          }
        });

        return reports;
      },

      searchPdfs(regexp) {
        let pdfs = [];

        this.pdfList.forEach(pdf => {
          if (regexp.test(pdf.displayName)) {
            pdfs.push(pdf);
          }
        });

        return pdfs;
      },

      searchCdas(regexp) {
        let cdas = [];

        this.cdaList.forEach(cda => {
          if (regexp.test(cda.displayName)) {
            cdas.push(cda);
          }
        });

        return cdas;
      },

      updateQuery() {
        // not redirect, just replace the string
        this.$router.replace({path: 'search', query: {category: 'document', query: this.inputQuery}});
        this.searchDocument(this.inputQuery);
      }
    }
  }

  let stringToArray = string => {
    return string.split(/(\s+)/).filter(e => {
      return e.trim().length > 0;
    });
  }
</script>

<style scoped lang="scss">
  @import "../../../stylesheets/mixins/flex";

  $color-base: #0060ff;
  $color-font: #58595b;
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  button {
    border: none;
    cursor: pointer;
    background-color: #2196F3;
    color: #fff;
    padding: 5px 10px;
    font-size: 14px;
  }

  button:hover {
    background-color: #0060ff;
  }

  h2 {
    font-size: 1.5em;
    color: $color-font;
    margin-top: 2.0em;
    text-align: center;
  }

  p {
    margin-top: 1.0em;
    font-size: 0.85em;
  }

  .list {
    margin: 0 auto;
  }

  .form-control {
    font-size: 0.85em;
  }

  .form {
    @include flex-box();
    @include flex-wrap(wrap);

    .form__input {
      @include flex(1, 0, 70%);
    }

    .form__button {
      @include flex(1, 0, 20%);
    }
  }

</style>